import { ca } from '@cian/analytics';

export function trackDomrfBlockClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'direct_links',
    label,
  });
}
